import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { cn } from '@/lib/utils';

export function TopicSelector({onChange}) {
  const dsaTopics = [
    "Arrays",
    "Linked Lists",
    "Stacks",
    "Queues",
    "Hashing",
    "Recursion",
    "Sorting Algorithms",
    "Searching Algorithms",
    "Bit Manipulation",
    "Greedy Algorithms",
    "Dynamic Programming",
    "Graph Algorithms",
    "Tree Data Structure",
    "Binary Search Trees",
    "Heaps & Priority Queues",
    "Trie Data Structure",
    "Backtracking",
    "Sliding Window",
    "Divide and Conquer",
    "Number Theory",
    "String Algorithms",
    "Topological Sorting",
    "Segment Tree",
    "Fenwick Tree (Binary Indexed Tree)",
    "Disjoint Set Union (DSU)",
    "KMP Algorithm",
    "Rabin-Karp Algorithm",
    "Bellman-Ford Algorithm",
    "Dijkstra's Algorithm",
    "Floyd-Warshall Algorithm",
    "Kadane's Algorithm",
    "Two Pointers Technique"
];

  return (
    <div className="space-y-2">
      <Label htmlFor="tech-stack-select">Select Topic:</Label>
      <Select onValueChange={onChange}>
        <SelectTrigger id="tech-stack-select" className="w-full">
          <SelectValue placeholder="Select Topic" />
        </SelectTrigger>
        <SelectContent>
          {dsaTopics.map((stack, index) => (
            <SelectItem key={index} value={stack}>
              {stack}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
